import { H5 } from "@sellar-io/components";
import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { OrderStage } from "../helpers";
import { generateOrderPaymentStatusText } from "./OrderPaymentStatusLegacy.shared";

export type OrderPaymentStatusProps = {
  paymentDate?: Date | null;
  paymentStatus: OrderGetResponseType["paymentStatus"];
  paymentTerms?: "credit" | "proforma" | "paymentOnDelivery" | null;
  orderStage: OrderStage;
  stripeInvoiceId?: string | null;
  invoiceCreationStage: OrderGetResponseType["Supplier"]["invoiceCreationStage"];
  confirmedAt: Date | null;
  orderPrice: number;
  paymentType: OrderGetResponseType["paymentType"];
  hasPaymentLink: boolean;
};

export const OrderPaymentStatusLegacy = (
  props: OrderPaymentStatusProps,
): React.ReactElement => {
  const confirmationText = "finalisation";
  return (
    <div className="flex flex-col gap-2">
      <H5>Status</H5>
      <div>
        {generateOrderPaymentStatusText({ ...props, confirmationText })}
      </div>
    </div>
  );
};
